<template>
    <div class="player-container">
        <LoadingOverlay></LoadingOverlay>
    </div>
</template>

<script setup lang="ts">
import LoadingOverlay from "./LoadingOverlay.vue";
</script>
